module.exports = __webpack_public_path__ + "static/media/logotipo.b0eb00ac.svg";